(function () {
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* carousels */
  qa('[data-el-car]').forEach(function (c) {
    var t = c.querySelector('.el-track');
    if (!t) return;
    var step = function () { var f = t.firstElementChild; return f ? f.getBoundingClientRect().width + 16 : 300; };
    var p = c.querySelector('[data-el-prev]'), n = c.querySelector('[data-el-next]');
    if (p) p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
    var dw = c.querySelector('.el-cdots');
    if (dw) {
      var build = function () {
        var pages = Math.max(1, Math.round((t.scrollWidth - t.clientWidth) / step()) + 1);
        dw.innerHTML = '';
        if (pages < 2) return;
        for (var i = 0; i < pages; i++) { var d = document.createElement('button'); d.type = 'button'; d.className = 'el-cdot'; d.setAttribute('aria-label', 'Slide ' + (i + 1)); (function (k) { d.addEventListener('click', function () { t.scrollTo({ left: k * step(), behavior: 'smooth' }); }); })(i); dw.appendChild(d); }
        upd();
      };
      var upd = function () { var i = Math.round(t.scrollLeft / step()); qa('.el-cdot', dw).forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); };
      t.addEventListener('scroll', function () { upd(); }, { passive: true });
      window.addEventListener('resize', build);
      build();
    }
  });

  /* gallery carousel */
  qa('[data-el-gal]').forEach(function (g) {
    var tr = g.querySelector('[data-el-slides]');
    if (!tr) return;
    var slides = tr.children, ths = qa('.el-gal__th', g), dots = qa('.el-gal__dot', g), cur = 0;
    function mark(i) {
      cur = i;
      ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var th = ths[i];
      if (th && th.parentNode) { var box = th.parentNode; box.scrollTo({ left: th.offsetLeft - box.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' }); }
    }
    function go(i) {
      var n = slides.length; i = (i + n) % n;
      tr.scrollTo({ left: slides[i].offsetLeft - tr.offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    var t;
    tr.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var i = Math.round(tr.scrollLeft / tr.clientWidth); if (i !== cur) mark(i); }, 60);
    }, { passive: true });
    ths.forEach(function (th, k) { th.addEventListener('click', function () { go(k); }); });
    var p = g.querySelector('[data-el-gprev]'), n = g.querySelector('[data-el-gnext]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
  });

  /* offers */
  function paint(root, o) {
    var set = function (sel, v) { qa(sel, root).forEach(function (e) { e.textContent = v; }); };
    set('[data-el-now]', o.dataset.now);
    set('[data-el-was]', o.dataset.was);
    set('[data-el-save]', o.dataset.save);
    qa('[data-el-sticky] [data-el-now]').forEach(function (e) { e.textContent = o.dataset.now; });
    qa('[data-el-ship]', root).forEach(function (sh) { sh.classList.toggle('is-on', (Number(o.dataset.qty) || 0) >= (Number(sh.dataset.min) || 6)); });
  }
  qa('[data-el-offers]').forEach(function (box) {
    var root = box.closest('[data-el-product]') || document;
    var offers = qa('.el-offer', box);
    offers.forEach(function (o) {
      o.addEventListener('click', function () {
        offers.forEach(function (x) { x.classList.remove('is-on'); });
        o.classList.add('is-on');
        paint(root, o);
      });
    });
    var on = box.querySelector('.el-offer.is-on') || offers[0];
    if (on) { on.classList.add('is-on'); paint(root, on); }
  });

  /* add to cart */
  function add(item, btn) {
    btn.disabled = true;
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: item })
      });
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.status) { btn.disabled = false; alert(d.description || d.message); return; }
      window.location.href = (btn.dataset.go === 'checkout') ? '/checkout' : '/cart';
    }).catch(function () { btn.disabled = false; });
  }
  qa('[data-el-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn;
      var root = btn.closest('[data-el-product]');
      if (btn.hasAttribute('data-el-use-offer')) {
        src = (root || document).querySelector('.el-offer.is-on') || btn;
      }
      var vid = src.dataset.variant;
      var items;
      if (vid) {
        items = [{ id: Number(vid), quantity: 1 }];
      } else {
        var tot = Number(src.dataset.qty) || 1;
        var base = Number(src.dataset.base || btn.dataset.base);
        /* reads the Kaching offer automatically (updates itself) */
        var deal = 'P3ri', pp = 8700204220551, B = null;
        try {
          var ks = document.querySelector('script.kaching-bundles-deal-block-settings');
          if (ks) {
            var cfg = JSON.parse(ks.textContent);
            if (cfg.nanoId) deal = cfg.nanoId;
            if (ks.dataset.productId) pp = Number(ks.dataset.productId);
            (cfg.dealBars || []).forEach(function (b) {
              if (b.dealBarType === 'bxgy' && (b.buyQuantity + b.getQuantity) === tot) B = [b.id, b.buyQuantity, b.getQuantity];
            });
          }
        } catch (e) {}
        if (!B) B = { 3: ['QVL5', 2, 1], 6: ['l_N1', 3, 3], 7: ['tZmD', 4, 3] }[tot];
        if (B) {
          var bid = Math.random().toString(36).slice(2, 6);
          items = [
            { id: base, quantity: B[2], properties: { __kaching_bundles: JSON.stringify({ id: bid, deal: deal, bar: B[0], main: true, bxgy: true }) } },
            { id: base, quantity: B[1], properties: { __kaching_bundles: JSON.stringify({ deal: deal, pp: pp, main: true, id: bid, bar: B[0] }) } }
          ];
        } else {
          items = [{ id: base, quantity: tot }];
        }
      }
      add(items, btn);
    });
  });

  /* smooth scroll to offers */
  qa('[data-el-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var h = a.getAttribute('href') || '';
      if (h.charAt(0) !== '#') return;
      var t = document.querySelector(h);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* videos */
  qa('[data-el-video]').forEach(function (w) {
    var v = w.querySelector('video');
    if (!v) return;
    v.removeAttribute('controls');
    w.addEventListener('click', function () {
      if (v.paused) { qa('video').forEach(function (x) { if (x !== v) x.pause(); }); v.play(); } else { v.pause(); }
    });
    v.addEventListener('play', function () { w.classList.add('is-play'); });
    v.addEventListener('pause', function () { w.classList.remove('is-play'); });
  });

  /* countdown */
  qa('[data-el-cd]').forEach(function (cd) {
    var mins = Number(cd.dataset.min) || 120, key = 'el_cd_end', end;
    try { end = Number(sessionStorage.getItem(key)); } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
    var h = cd.querySelector('[data-h]'), m = cd.querySelector('[data-m]'), s = cd.querySelector('[data-s]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    (function tick() {
      var left = Math.max(0, end - Date.now());
      if (left === 0) { end = Date.now() + mins * 60000; left = mins * 60000; }
      var t = Math.floor(left / 1000);
      h.textContent = pad(Math.floor(t / 3600)); m.textContent = pad(Math.floor(t % 3600 / 60)); s.textContent = pad(t % 60);
      setTimeout(tick, 1000);
    })();
  });

  /* sticky */
  qa('[data-el-sticky]').forEach(function (bar) {
    var atc = document.querySelector('.el-atc');
    var chk = function () {
      if (!atc) { bar.classList.toggle('is-on', window.scrollY > 700); return; }
      var r = atc.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0);
    };
    window.addEventListener('scroll', chk, { passive: true });
    chk();
  });

  /* animations */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el, to, dur, fmt) {
    if (reduce) { el.textContent = fmt(to); return; }
    var t0 = null;
    (function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(Math.round(to * e));
      if (k < 1) requestAnimationFrame(step);
    })(performance.now());
  }
  function onView(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } }); }, { threshold: 0.3 });
    io.observe(el);
  }
  /* stats count-up */
  qa('[data-el-count]').forEach(function (el) {
    var raw = el.getAttribute('data-el-count'), m = raw.match(/^(\D*)(\d+)(.*)$/);
    if (!m) return;
    var pre = m[1], n = Number(m[2]), suf = m[3];
    el.textContent = pre + '0' + suf;
    onView(el, function () { countUp(el, n, 1300, function (v) { return pre + v + suf; }); });
  });
  /* sold bar */
  qa('[data-el-sold]').forEach(function (box) {
    var to = Number(box.getAttribute('data-el-sold')), bar = box.querySelector('.el-sold__bar span'), num = box.querySelector('[data-el-sold-n]');
    if (reduce) return;
    bar.style.width = '0%'; if (num) num.textContent = '0';
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      bar.style.width = to + '%';
      if (num) countUp(num, to, 900, function (v) { return v; });
    }); });
  });
  /* timeline */
  qa('[data-el-tl]').forEach(function (tl) {
    document.documentElement.classList.add('js-anim');
    var steps = qa('.el-step', tl);
    var upd = function () {
      var r = tl.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.max(0, Math.min(1, (vh * 0.8 - r.top) / r.height));
      tl.style.setProperty('--fill', (reduce ? 100 : p * 100) + '%');
      steps.forEach(function (s) { if (s.getBoundingClientRect().top < vh * 0.9) s.classList.add('is-in'); });
    };
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });
})();
/* every buy button: go to the on-site checkout page with the chosen pack */
(function () {
  function planOf(v) { var m = v && String(v).match(/plan_[A-Za-z0-9]+/); return m ? m[0] : ''; }
  function go() {
    document.querySelectorAll('[data-el-product] .el-offer').forEach(function (o) {
      ['whopOnce', 'whopM1', 'whopM3', 'whopM6'].forEach(function (k) {
        var p = planOf(o.dataset[k]);
        if (p) o.dataset[k] = '/pages/checkout?plan=' + p;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-el-add]') : null;
    if (!b) return;
    var plan = '';
    var root = b.closest('[data-el-product]') || document.querySelector('[data-el-product]');
    var o = root && (root.querySelector('.el-offer.is-on') || root.querySelector('.el-offer'));
    if (o) {
      var cb = root.querySelector('[data-sns-cb]'), sel = root.querySelector('[data-sns-dur]');
      var d = sel ? sel.value : 'm1';
      var k = (cb && cb.checked) ? 'whop' + d.charAt(0).toUpperCase() + d.slice(1) : 'whopOnce';
      plan = planOf(o.dataset[k]) || planOf(o.dataset.whopOnce);
    }
    if (!plan) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/pages/checkout?plan=' + plan;
  }, true);
})();
